"use strict";
/*
 * Created on 09.05.2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var big_decimal_1 = require("@logio/big-decimal");
/**
 * Utility method for numbers
 *
 * @author Tomáš Leity
 */


var NumberUtils =
/*#__PURE__*/
function () {
  function NumberUtils() {
    _classCallCheck(this, NumberUtils);
  }

  _createClass(NumberUtils, null, [{
    key: "toFixed",

    /**
     * Converts number to string with defined decimal places
     * @param ref
     * @param decimalPlaces
     * @param trailingZeros
     * @param rounding
     * @returns string
     */
    value: function toFixed(ref, decimalPlaces) {
      var trailingZeros = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var rounding = arguments.length > 3 ? arguments[3] : undefined;

      try {
        var v = big_decimal_1.bigdecimal(ref);
        var r;

        if (rounding) {
          r = v.toFixed(decimalPlaces, rounding);
        } else {
          r = v.toFixed(decimalPlaces);
        } //FIXME this is wrong. Conversion from string to number loses precision and can not be trusted.


        return !trailingZeros ? (+r).toString() : r;
      } catch (error) {
        throw new Error('NumberUtils.toFixed: ' + error);
      }
    }
    /**
     * Converts number into string
     * @param ref
     * @returns string
     */

  }, {
    key: "toString",
    value: function toString(ref) {
      return ref && ref.toString ? ref.toString() : ref;
    }
    /**
     * Converts percentage into number.
     * @param ref
     * @param bigNumber
     * @returns converted percentage into number
     */

  }, {
    key: "percentageToNumber",
    value: function percentageToNumber(ref) {
      var bigNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      try {
        var result = big_decimal_1.bigdecimal(ref).div(100);
        return bigNumber ? result : result.toNumber();
      } catch (error) {
        throw new Error('NumberUtils.percentageToDecimal: ' + error);
      }
    }
    /**
     * Converts number into percentage
     * @param ref
     * @param bigNumber
     * @returns converted number into percentage
     */

  }, {
    key: "numberToPercentage",
    value: function numberToPercentage(ref) {
      var bigNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      try {
        var result = big_decimal_1.bigdecimal(ref).times(100);
        return bigNumber ? result : result.toNumber();
      } catch (error) {
        throw new Error('NumberUtils.numberToPercentage: ' + error);
      }
    }
    /**
     * Converts decimal number to negative decimal number
     * @param value
     */

  }, {
    key: "toNegativeDecimal",
    value: function toNegativeDecimal(value) {
      var numberValue = value.toNumber();
      return big_decimal_1.bigdecimal(numberValue !== 0 ? -Math.abs(numberValue) : numberValue);
    }
    /**
     * Counts decimal places based on string format number.
     *
     * @param numString String number to count decimal places.
     */

  }, {
    key: "countDecimalPlaces",
    value: function countDecimalPlaces(numString) {
      if (isNaN(+numString)) {
        throw new Error("NumberUtils.countDecimalPlaces: specified value is not a number: ".concat(numString));
      }

      var decimalPart = numString.split('.')[1];
      return decimalPart ? decimalPart.length : 0;
    }
  }]);

  return NumberUtils;
}();

exports.NumberUtils = NumberUtils;